import React, { useEffect } from "react";
import { I18n } from 'aws-amplify';
import { Authenticator, useAuthenticator, translations, Button } from '@aws-amplify/ui-react';
import {
  MainWrapper,
  FormWrapper,
  LogoContainer,
  WrapperForgotPassword,
  FormTitle,
  FormSubtitle,
  FormFooter,
  Footer,
  SignUpLink
} from "./Signin.styled";
import { Loading } from "../loading";
import { SigninGlobalStyles } from "./SigninGlobalStyles";
import { AnimatedGradientBackground } from "./components";

import '@aws-amplify/ui-react/styles.css';
import './Signin.css';

I18n.putVocabularies(translations);
I18n.setLanguage('en');

I18n.putVocabulariesForLanguage('en', {
    'Sign in': 'Log in',
    'Username': 'Email',
    'Password': 'Password',
    'Forgot your password?': 'Forgot Password?',
    'Create a new account': 'Sign up',
    'Reset Password': 'Forgot password',
    'Enter your Email': 'Email',
    'Send code': 'Enter your email',
    'Change Password': 'Log In',
})

const authenticatorComponents = {
    SignIn: {
        Header() {
            return (
              <>
                <FormTitle>Welcome back</FormTitle>
                <FormSubtitle>
                  First time here?{' '}
                  <SignUpLink href="#" onClick={(e) => { e.preventDefault(); }}>
                    Sign up for free.
                  </SignUpLink>
                </FormSubtitle>
              </>
            );
        },
        Footer() {
            const { toResetPassword } = useAuthenticator();

            return (
              <>
                  <WrapperForgotPassword>
                    <Button onClick={toResetPassword} variation="link">Forgot password?</Button>
                  </WrapperForgotPassword>
              </>
            );
        }
    },
    ResetPassword: {
        Header() {
            return (
              <>
                  <FormTitle>Forgot password</FormTitle>
                  <FormSubtitle>Don't worry, it happens sometimes. Please enter the email associated with your account.</FormSubtitle>
              </>
            );
        }
    },
    ForceNewPassword: {
        Header() {
            return (
              <>
                  <FormTitle>Create password</FormTitle>
                  <FormSubtitle>Create your new password and jump right back into the joyful ANN experience!</FormSubtitle>
              </>
            );
        }
    },
    ConfirmResetPassword: {
        Header() {
            return (
              <>
                  <FormTitle>Verification code</FormTitle>
                  <FormSubtitle>We sent a code to your email, please enter the code to verify your account and password, finally jump right back into the joyful ANN experience!</FormSubtitle>
              </>
            );
        }
    }
};

const authenticatorFormFields = {
    signIn: {
        username: {
            label: 'Email',
            labelHidden: false,
        },
        password: {
            label: 'Password',
            labelHidden: false,
        },
    },
    forceNewPassword: {
        password: {
            labelHidden: true,
        },
        confirm_password: {
            labelHidden: true,
        }
    },
    resetPassword: {
        username: {
          labelHidden: true,
      }
    },
    confirmResetPassword: {
        confirmation_code: {
            labelHidden: true,
        },
        password: {
            labelHidden: true,
        },
        confirm_password: {
            labelHidden: true,
        }
    }
};

const Signin = ({ children }) => {
    const { authStatus  } = useAuthenticator(context => [context.user]);

    useEffect(() => {
        if (window.toggleJSDWidget) {
            window.toggleJSDWidget();
        }
    }, []);

    return (
      <>
          <SigninGlobalStyles />
          {authStatus === 'configuring' && <Loading />}
          {authStatus === 'authenticated' ? [children] : (
            <MainWrapper>
                <AnimatedGradientBackground />
                <FormWrapper>
                    <LogoContainer>
                        <img src="/logo.png" alt="Logo" />
                    </LogoContainer>
                    <Authenticator
                      hideSignUp={true}
                      components={authenticatorComponents}
                      formFields={authenticatorFormFields}
                      signUpAttributes={[ 'email', 'name', 'phone_number' ]} />
                </FormWrapper>
                <FormFooter>
                    <a href="https://aims.ai/privacy-policy" target="_blank" rel="noopener noreferrer">Privacy policy</a>
                    <div className="divider"></div>
                    <a href="https://aims.ai/terms-of-use" target="_blank" rel="noopener noreferrer">Terms of use</a>
                </FormFooter>
                <Footer>Powered by AIMS OS</Footer>
            </MainWrapper>
          )}
      </>
    );
};

export default Signin;